import { ThemeProvider } from "styled-components";
import GlobalStyle from "./styles";
import { theme } from "./theme";

const StyledProvider = ({ children }) => {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      {children}
    </ThemeProvider>
  );
};

export default StyledProvider;
